import type { AgentActivitySession, AgentActivityTurn } from "./types.ts";

export function providerForkBindingAllowsAttempt(
  turn: Pick<
    AgentActivityTurn,
    "providerForkBindingAvailable" | "providerForkBindingState"
  >
): boolean {
  switch (turn.providerForkBindingState) {
    case "bound":
      return true;
    case "recovery_required":
    case "unavailable":
      return false;
    default:
      return turn.providerForkBindingAvailable === true;
  }
}

export interface AgentActivityForkSessionThroughTurnInput {
  workspaceId: string;
  sourceAgentSessionId: string;
  targetAgentSessionId: string;
  requestId: string;
  turnId: string;
  signal?: AbortSignal;
}

export type AgentActivityForkSessionOperationStatus =
  | "accepted"
  | "committed"
  | "failed"
  | "unknown";

export interface AgentActivityForkSessionResult {
  operationId: string;
  requestId: string;
  sourceAgentSessionId: string;
  targetAgentSessionId: string;
  turnId: string;
  status: AgentActivityForkSessionOperationStatus;
  session: AgentActivitySession | null;
  error: string | null;
}
